// extracted by mini-css-extract-plugin
export var hidden = "_sv-0";